import { t } from "components/CentralDataMangement/translation/Translation";
import { OptionProps } from "components/common/utlis/TypeAnnotations";

interface DropDownList {
  status?: OptionProps[];
  userTypes?: OptionProps[];
}

export const createFilterConfig = (dropDownList: DropDownList) => {
  return [
    {
      name: "userName",
      fieldType: "text",
      placeholder: t("Username"),
      filterType: 'search',
      label: t("User Name")
    },
    {
      name: "phoneNumber",
      fieldType: "text", 
      placeholder: t("Phone number"),
      filterType: 'search',
      label: t("Phone number")
    }
  ];
};